import { render, staticRenderFns } from "./shopListFilter.vue?vue&type=template&id=a05b6fa4&scoped=true"
import script from "./shopListFilter.vue?vue&type=script&lang=js"
export * from "./shopListFilter.vue?vue&type=script&lang=js"
import style0 from "./shopListFilter.vue?vue&type=style&index=0&id=a05b6fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05b6fa4",
  null
  
)

export default component.exports